module.exports = [{"moduleId":1,"name":"sidebar.saleorder","icon":"far fa-file-alt","activeClass":"","submenus":[{"name":"sidebar.all","router":{"name":"SaleOrderAll"},"activeClass":""},{"name":"sidebar.create","router":{"name":"SaleOrderNew"},"activeClass":""}]},{"moduleId":3,"name":"sidebar.saletypes","icon":"fas fa-list-ul","router":{"name":"SaleType"},"activeClass":""},{"moduleId":2,"name":"sidebar.configuration","icon":"icon fas fa-wrench","activeClass":"","submenus":[{"subModuleId":1,"name":"sidebar.settings","router":{"name":"SaleConfigurationSetting"},"activeClass":""}]}]


//////////////////
// WEBPACK FOOTER
// ./src/components/apps/sales/sidebar.json
// module id = XfBz
// module chunks = 1